<script setup>
import { ref, onMounted } from 'vue';
import { useSertStore } from '@/stores/sertStore';
import { getListMessages } from '@/utils/services';
import BasePopularMessage from '@/components/ui/BasePopularMessage.vue';
import BaseTextarea from '@/components/ui/BaseTextarea.vue';

const storeSert = useSertStore();

const activeIndex = ref({});
const personalTexts = ref([])
const activeMessage = (index) => {
    const newActive = {}
    for(let i = 0; i < personalTexts.value?.length; i++) {
        newActive[i] = i === index ? !activeIndex.value[index] : false;
    }
    activeIndex.value = newActive;
}


onMounted( async() => {
    personalTexts.value = await getListMessages();
})

</script>
<template>
    <div class="message">
        <span class="message__label">Персональное сообщение и подпись</span>
        <div class="message__list-inner">
            <ul class="message__list message__scrollbar">
                <li @click="activeMessage(index)" :class="['message__item', {active: activeIndex[index]}]" v-for="text, index in personalTexts" :key="text.id">
                    <BasePopularMessage
                        :text="text"
                        :index
                        @activeMessage="activeMessage"
                    />
                </li>
            </ul>
        </div>
        <BaseTextarea />  
    </div>
</template>
<style lang='scss' scoped>
.v-enter-active,
.v-leave-active {
  transition: 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>